const isOperatorUserLoginLoading = (state) => {
  return state.secure.authState.operatorUserLoading
}

const getResetPasswordRequestState = (state) => {
  return state.secure.authState.resetPasswordRequestState
}

const getOperatorUser = (state) => {
  return state.secure.authState.operatorUser
}
const getOperator = (state) => {
  return state.secure.authState.operator
}

const getToken = (state) => {
  return state.secure.authState.token
}

const isLoggedIn = (state) => {
  return state.secure.authState.token && state.secure.authState.operatorUser
}

const getRefreshToken = (state) => {
  return state.secure.authState.refreshToken
}

const getOperatorUserLoading = (state) => {
  return state.secure.authState.operatorUserLoading
}

const getFetchOperatorUserRequestState = (state) => {
  return state.secure.authState.fetchOperatorUserRequestState
}

const getResetPassVerificationRequestState = (state) => {
  return state.secure.authState.resetPassVerificationRequestState
}

const getResetPassEmailID = (state) => {
  return state.secure.authState.resetPassEmailID
}

const getRequires2FA = (state) => {
  return state.secure.authState.requires2FA
}

const getRequires2FASetup = (state) => {
  return state.secure.authState.requires2FASetup
}

const getChallengeId = (state) => {
  return state.secure.authState.challengeId
}

const getOtpauthUrl = (state) => {
  return state.secure.authState.otpauthUrl
}

const getManualKey = (state) => {
  return state.secure.authState.manualKey
}

const getSetupComplete = (state) => {
  return state.secure.authState.setupComplete
}

const AuthSelectors = {
  getOperatorUser,
  isOperatorUserLoginLoading,
  getToken,
  getRefreshToken,
  isLoggedIn,
  getOperatorUserLoading,
  getResetPasswordRequestState,
  getFetchOperatorUserRequestState,
  getResetPassVerificationRequestState,
  getResetPassEmailID,
  getOperator,
  getRequires2FA,
  getRequires2FASetup,
  getChallengeId,
  getOtpauthUrl,
  getManualKey,
  getSetupComplete,
}

export default AuthSelectors
